import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Suppress errors during login/logout
    if (window.isLoggingIn || window.isLoggingOut) {
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Suppress errors during login/logout
    if (window.isLoggingIn || window.isLoggingOut) {
      return;
    }

    // Only log errors if not during login/logout
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    // Suppress errors during login/logout
    if (window.isLoggingIn || window.isLoggingOut) {
      return this.props.children;
    }

    if (this.state.hasError) {
      return (
        <div className="error-container">
          <h2>Algo correu mal</h2>
          <p>Por favor, recarregue a página.</p>
          <button onClick={() => window.location.reload()}>
            Recarregar Página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
